module.exports = __webpack_public_path__ + "img/weekly-logo-icon.f65d2cbb.png";